<div class="card">
    <div class="card-body">
        <h3>
            {{ carousel().title }} {{ carousel().count }}
            @if (carousel().trackAllOrdersUrl) {
                <span class="pace-link-font">
                    <a class="pace-link" [href]="carousel().trackAllOrdersUrl" target="_blank">{{
                        carousel().trackAllOrdersLabel
                    }}</a>
                </span>
            }
        </h3>
        <carousel #carouselView [noWrap]="true" [showIndicators]="false" interval="0">
            @if (carousel().slides.length === 0) {
                <slide class="no-records">
                    <span>{{ carousel().emptyText }}</span>
                </slide>
            }

            @for (slide of carousel().slides; track $index) {
                <slide>
                    <div class="row flex-nowrap mx-2 my-1">
                        @for (column of slide; track $index) {
                            <div class="material-participants-section col d-flex flex-column px-0">
                                @for (item of column; track item.id) {
                                    @if (item.kind === 'material') {
                                        <ng-container
                                            *ngTemplateOutlet="material; context: { $implicit: asMaterial(item) }"
                                        ></ng-container>
                                    } @else {
                                        <ng-container
                                            *ngTemplateOutlet="participant; context: { $implicit: asParticipant(item) }"
                                        ></ng-container>
                                    }
                                }
                            </div>
                        }
                    </div>
                </slide>
            }
            <div class="carousel-indicators">
                @for (slide of carousel().slides; track $index; let index = $index) {
                    <button
                        type="button"
                        aria-current="true"
                        [class.active]="isActiveSlide(index)"
                        [attr.aria-label]="carousel().title + ' ' + (index + 1)"
                        (click)="selectSlide(index)"
                    ></button>
                }
            </div>
        </carousel>
    </div>
</div>

<ng-template #material let-item>
    <ul>
        <li class="user-select-auto horizontal-icons-list">
            {{ item.headline }}
            @if (item.isDangerousGoods) {
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            }
            @if (item.isTaxiBillable) {
                <fa-icon [icon]="faTaxi"></fa-icon>
            }
            @if (item.isQualityPart) {
                <fa-icon [icon]="faSearch"></fa-icon>
            }
            @if (item.isRentalTool) {
                <fa-icon [icon]="faWrench"></fa-icon>
            }
        </li>
        @if (item.trackOrderUrl) {
            <li>
                <a class="pace-link" [href]="item.trackOrderUrl" target="_blank">{{ item.trackOrderLabel }}</a>
            </li>
        }
        <li class="user-select-auto">
            {{ item.description }}
            @if (item.smartSensorUrl) {
                <span>
                    <a
                        class="pace-link"
                        [href]="item.smartSensorUrl"
                        target="_blank"
                        [attr.aria-label]="item.smartSensorAriaLabel"
                        ><fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon
                    ></a>
                </span>
            }
        </li>
        <li>
            @if (item.sparePartCatalogUrl) {
                <span class="user-select-auto">
                    {{ item.materialNumber }}
                    <a
                        class="pace-link"
                        target="_blank"
                        [href]="item.sparePartCatalogUrl"
                        [attr.aria-label]="item.sparePartCatalogAriaLabel"
                    >
                        <fa-icon [icon]="faExternalLinkSquareAlt"></fa-icon>
                    </a>
                </span>
            } @else {
                <span>({{ item.materialNumber }})</span>
            }
        </li>
        @if (item.pickedUpText) {
            <li>{{ item.pickedUpText }}</li>
        } @else {
            <li class="d-flex align-items-center">
                <span> <fa-icon [icon]="faInfoCircle"></fa-icon>&nbsp; </span>
                @if (item.isNotReceived) {
                    <span class="text-muted">{{ item.notReceivedLabel }}</span>
                } @else {
                    <button class="btn btn-link ps-0" (click)="materialPickupSelect.emit(item)">
                        <span>{{ item.pickupLabel }}</span>
                    </button>
                }
            </li>
        }
    </ul>
</ng-template>

<ng-template #participant let-item>
    <ul>
        <li>{{ item.name }}</li>
        <li>
            <a class="cursor-pointer" (click)="participantEmailSelect.emit(item)">{{ item.email }}</a>
        </li>
    </ul>
</ng-template>
